<template>
  <div class="simple-formatter mb-1">
    <div class="field-container mr-1">
      <p class="description">{{widgetConfig.message}}</p>
    </div>
    <div class="buttons">
      <button class="btn btn-primary" type="button" @click="resolveClicked">
        Resolve
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    field: {
      required: true,
    },
  },
  computed: {
    query: function () {
      return this.field.value.queries.find(
        (q) => q.query.widgetSystemName === "Sharedo.Core.Case.DataGraph.FieldQueries.PropertyValueQuery"
      );
    },
    widgetConfig: function () {
      return this.query.query.widgetConfig;
    },
  },
  methods: {
    resolveClicked: function () {
      const config = this.widgetConfig;

      const args = {};
      args[config.property] = config.value;

      this.logDebug("Resolving simple format query.", {
        args,
        fieldQueryName: this.query.name,
      });

      this.$emit("resolve", {
        args,
        fieldQueryName: this.query.name,
      });
    },
  },
  emits: ["resolve"],
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables";

.simple-formatter {
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > .field-container {
    flex-grow: 1;

    & > .description {
      font-weight: bold;
      color: $secondary
    }
  }

  & > .buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    & > .help-link {
      margin-left: 3px;
    }
  }
}
</style>
